import './CustomPacingRequestedCell.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import type { DropdownOption } from '../../../../../common/Dropdown';
import Dropdown from '../../../../../common/Dropdown';
import Loader from '../../../../../common/Loader';
import { onLineItemFailureUpdate } from '../../../../../common/utils';
import type { CustomPacingRequestedOption, DisplayEnum } from '../../../../../configs';
import {
  convertConfigToDropdownOption,
  convertConfigToDropDownOptions,
  customPacingRequestedOptions,
} from '../../../../../configs';
import { useUpdateLineItem } from '../../hooks';
import { CUSTOM_PACING_REQUESTED_ICON_CONFIG } from './constants';

type Props = {
  lineItemId: string;
  customPacingRequested: DisplayEnum<CustomPacingRequestedOption>;
};

const [block, element] = bem('custom-pacing-requested-cell');

const CustomPacingRequestedCell = ({ lineItemId, customPacingRequested }: Props): React.JSX.Element => {
  const { updateLineItemField, loading } = useUpdateLineItem(lineItemId, 'cpRequested', onLineItemFailureUpdate);

  const handleChange = (option: DropdownOption<CustomPacingRequestedOption | 'UNRECOGNIZED'> | null): void => {
    if (option) {
      updateLineItemField(option.value);
    }
  };

  return (
    <div
      className={block([
        loading ? 'loading' : '',
        customPacingRequested.key === customPacingRequestedOptions.DEFAULT.key ? 'default-value' : '',
      ])}
    >
      <Dropdown
        onChange={handleChange}
        value={convertConfigToDropdownOption<CustomPacingRequestedOption>(customPacingRequested)}
        options={convertConfigToDropDownOptions(customPacingRequestedOptions)}
        isSearchable={false}
        isDisabled={loading}
        prependIcon={
          <div className={element('icon')} data-testid="prepend-icon">
            {CUSTOM_PACING_REQUESTED_ICON_CONFIG[customPacingRequested.key]}
          </div>
        }
        appendIcon={loading ? <Loader /> : null}
      />
    </div>
  );
};

export default CustomPacingRequestedCell;
